import React from "react";

import talentLenzApplicationVolumeProblemFairnessIcon from "../../images/talentlenz-application-volume-problem-fairness-icon.png";
import talentLenzApplicationVolumeProblemHrScreeningPhoto from "../../images/talentlenz-application-volume-problem-hr-screening-photo.jpg";
import talentLenzApplicationVolumeProblemHrScreeningPhotoWebp from "../../images/talentlenz-application-volume-problem-hr-screening-photo.webp";
import talentLenzApplicationVolumeProblemOverloadOverlay from "../../images/talentlenz-application-volume-problem-overload-overlay.png";

import "./talentlenz-application-volume-problem-component.css";

const TALENTLENZ_APPLICATION_VOLUME_SIGNALS = [
  "Time pressure",
  "Inconsistent screening",
  "Missed talent",
];

export default function TalentLenzApplicationVolumeProblem() {
  return (
    <section
      id="talentlenz-application-volume-problem"
      className="talentlenz-application-volume-problem"
      aria-labelledby="talentlenz-application-volume-problem-title"
    >
      <div className="talentlenz-application-volume-problem__inner">
        <div className="talentlenz-application-volume-problem__copy">
          <p className="talentlenz-application-volume-problem__eyebrow">
            The screening problem
          </p>

          <h2
            id="talentlenz-application-volume-problem-title"
            className="talentlenz-application-volume-problem__title"
            aria-label="Manual screening turns opportunity into pressure."
          >
            <span
              className="talentlenz-application-volume-problem__title-layout talentlenz-application-volume-problem__title-layout--desktop"
              aria-hidden="true"
            >
              Manual screening turns
              <br />
              opportunity into
              <br />
              pressure.
            </span>

            <span
              className="talentlenz-application-volume-problem__title-layout talentlenz-application-volume-problem__title-layout--landscape"
              aria-hidden="true"
            >
              Manual screening
              <br />
              turns opportunity
              <br />
              into pressure.
            </span>

            <span
              className="talentlenz-application-volume-problem__title-layout talentlenz-application-volume-problem__title-layout--portrait"
              aria-hidden="true"
            >
              Manual screening turns
              <br />
              opportunity into pressure.
            </span>

            <span
              className="talentlenz-application-volume-problem__title-layout talentlenz-application-volume-problem__title-layout--mobile"
              aria-hidden="true"
            >
              Manual screening
              <br />
              turns opportunity
              <br />
              into pressure.
            </span>
          </h2>

          <p className="talentlenz-application-volume-problem__body">
            When application volume rises, consistency becomes harder to
            maintain. Teams rush, criteria drift and strong applicants can
            disappear before they are properly considered.
          </p>

          <ul
            className="talentlenz-application-volume-problem__signals"
            aria-label="Problems caused by manual applicant screening"
          >
            {TALENTLENZ_APPLICATION_VOLUME_SIGNALS.map((signal) => (
              <li
                key={signal}
                className="talentlenz-application-volume-problem__signal"
              >
                {signal}
              </li>
            ))}
          </ul>
        </div>

        <figure className="talentlenz-application-volume-problem__visual">
          <picture className="talentlenz-application-volume-problem__picture">
            <source
              srcSet={talentLenzApplicationVolumeProblemHrScreeningPhotoWebp}
              type="image/webp"
            />

            <img
              className="talentlenz-application-volume-problem__photo"
              src={talentLenzApplicationVolumeProblemHrScreeningPhoto}
              alt="A recruitment team reviewing applicant information together."
              loading="lazy"
              decoding="async"
            />
          </picture>

          <img
            className="talentlenz-application-volume-problem__overlay"
            src={talentLenzApplicationVolumeProblemOverloadOverlay}
            alt=""
            aria-hidden="true"
          />

          <figcaption className="talentlenz-application-volume-problem__photo-caption">
            Every application deserves structured attention.
          </figcaption>
        </figure>

        <aside
          className="talentlenz-application-volume-problem__principle"
          aria-label="TalentLenz fairness principle"
        >
          <img
            className="talentlenz-application-volume-problem__principle-icon"
            src={talentLenzApplicationVolumeProblemFairnessIcon}
            alt=""
            aria-hidden="true"
          />

          <div className="talentlenz-application-volume-problem__principle-content">
            <p className="talentlenz-application-volume-problem__principle-label">
              The principle
            </p>

            <p className="talentlenz-application-volume-problem__principle-copy">
              Fairness should not collapse under volume.
            </p>
          </div>
        </aside>
      </div>
    </section>
  );
}